/** Ids for embedded objects (copies) that Firestore does not generate for us. */
export function createId(): string {
  const crypto = globalThis.crypto;
  if (crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();

  // Non-secure fallback for environments without WebCrypto.
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * Firestore rejects `undefined`. Anything optional is either a real value or
 * an explicit `null`, so strip undefined recursively before writing.
 */
export function pruneUndefined<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => pruneUndefined(item)) as unknown as T;
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, item] of Object.entries(value as Record<string, unknown>)) {
      if (item === undefined) continue;
      result[key] = pruneUndefined(item);
    }
    return result as T;
  }
  return value;
}
